import { TVehicle } from "types";

export const getBackdropPicture = (vehicle: TVehicle): string | undefined => {
  let backdropPicture;
  switch (true) {
    case !!vehicle.pictures && vehicle.pictures.length > 0:
      backdropPicture = vehicle.pictures[0].src;
      break;

    case !!vehicle.firstPicture && vehicle.firstPicture.length > 0:
      backdropPicture = vehicle.firstPicture;
      break;

    case !!vehicle.picturesCount && vehicle.picturesCount > 0:
      backdropPicture = `${vehicle.picturesPath}${vehicle.wgnr}_1.jpg`;
      break;
  }
  return backdropPicture;
};
